import { z } from 'zod'

export const Time = z.union([
  z.literal(
    `${z.union([z.number(), z.string()])}:${z.union([
      z.number(),
      z.string()
    ])}:${z.union([z.number(), z.string()])}`
  ),
  z.string()
])

export type Time = z.infer<typeof Time>
